import { VennueAccessRequestItem, VenueListAccessRequetsFilter } from '../../graphql/API';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

const venueListAccessRequestsQuery = /* GraphQL */ `
  query VenueListAccessRequests($filter: VenueListAccessRequetsFilter!) {
    venueListAccessRequests(filter: $filter) {
      items {
        offerID
        status
        userID
        user {
          id
          firstname
          lastname
          gender
          instagramHandle
          picture {
            thumbnail
            small
            medium
            large
          }
          tags
          instagramFollowers
          rating
          lifestyle
          rating
          tiktokHandle
        }
        offer {
          title
          shopifyProductID
          incentiveValue
          postOnTikTokVideo
          tag
          category
        }
        createdAt
        incentiveValue
        updatedAt
        totalRequested
        totalDeclined
        totalRatings
        shippingAddress {
          id
          address1
          address2
          city
          postalCode
          stateProvince
          country
          countryCode
        }
      }
    }
  }
`;

export const venueListAccessRequestsApi = async (
  filter: VenueListAccessRequetsFilter,
): Promise<VennueAccessRequestItem[]> => {
  const result = await executeGql<VennueAccessRequestItem[]>(venueListAccessRequestsQuery, {
    filter,
  });
  return processGqlResult<VennueAccessRequestItem[]>('venueListAccessRequests.items', result);
};
